module.exports = __webpack_public_path__ + "static/img/charm_level_94.689d50f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_94.png
// module id = RIq/
// module chunks = 0